module.exports = __webpack_public_path__ + "img/minimize-icon-used.dfc2a699.svg";